import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPersonaimpuestos } from '../api/consulaImpuestosApi';
import { getPersonalicencia } from '../api/consulaLicenciaApi';
import { getPersonaCivil } from '../api/consultaCivilApi';
import { getPersonaPredial } from '../api/consultaPredialApi';
import { getPersonaRpp } from '../api/consultaRppApi';
import { getPersonaVehicular } from '../api/consultaVehicularApi';
import { UseAuth } from "../hooks/useAuth";
import { withRouter } from '../hooks/withRouter';




const links = {
  vehicular: `/detalles`,
  licencias: `/licencias-detalles`,
  predial: `/predial-detalles`,
  impuestos: `/impuestos-detalles`,
  rpp: `/rpp-detalles`,
  civil: `/civil-detalles`

};

//colapsible en javaScrip

function BusquedaGeneral(props) {
  const { location } = props.router;


  return (

    <div className="results">
      <div className='top-bar2'>
        <div className="top-bar">

          <div className="logo">
            {/* Botón con apariencia de logo que lleva a la página principal */}
            <Link to="/">
              <button className="logo-button">
                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
<div className='generalOp'>
      <Getdata query={location.search} funcionPadron={getPersonaVehicular} nombre='Consulta Vehicular' link={links.vehicular} />
      <Getdata query={location.search} funcionPadron={getPersonaPredial} nombre='Consulta Predial' link={links.predial} />
      <Getdata query={location.search} funcionPadron={getPersonaimpuestos} nombre='Consulta Impuestos' link={links.impuestos} />
      <Getdata query={location.search} funcionPadron={getPersonalicencia} nombre='Consulta Licencias' link={links.licencias} />
      <Getdata query={location.search} funcionPadron={getPersonaRpp} nombre='Consulta RPP' link={links.rpp} />
      <Getdata query={location.search} funcionPadron={getPersonaCivil} nombre='Consulta Civil' link={links.civil} />

      </div>


    </div>


  );
}
function replaceSpecialCharacter(text) {
  return text.replace(/�/g, 'Ñ');
}

function Getdata(props) {
  const [data, setData] = useState([]);
  const { query, funcionPadron, nombre, link } = props
  const [isloading, setIsloading] = useState(true)
  const { accessToken } = UseAuth();
  const [error, setError]     = useState(null);


  useEffect(() => {
    setIsloading(true);
    funcionPadron(accessToken, query)
      .then((response) => {
        if (response?.code && response.code !== 200) {
          // tu API podría devolver { code:500, mensaje: ... }
          throw new Error(response.mensaje || 'Error en consulta');
        }
        setData(response);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsloading(false);
      });
  }, [accessToken, query, funcionPadron]);

  // 1) Mientras carga
  if (isloading) {
    return (
      <div className='padron'>
        <h1>Cargando info {nombre}…</h1>
      </div>
    );
  }

     if (error) {
    return (
      <div className='padron'>
        <h1>{nombre}</h1>
        <h2 style={{ color: '#cc0000', marginBottom: '1rem' }}>
          ❌ Error en el servidor, favor de consultar al administrador del sistema
        </h2>
      </div>
    );
  }

  if (data.length < 1 && !isloading) {
    return (
      <div className='padron'>
        <h1>{nombre}</h1>
        <div className="results-container">
          <p>Datos no encontrados para {nombre}</p>
        </div>
      </div>
    )

  }

  return (



    <div>
      <div className='padron'>
        <h1>{nombre}</h1>
        {/* <button type="button" className="collapsible">{nombre}</button> */}
        <div className="results-container">
          <ul>
            {data.map((d, index) => (
              <li className="res-list" key={index}>
                <Link to={`${link}/${d.ID ?? d.id}`}>
                  <h1>{replaceSpecialCharacter(d.NOMBRE ?? d.nombre)}</h1>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>

  )
}



export default withRouter(BusquedaGeneral);
